import ApiResourceManager from '../ApiResourceManager';

// The platform agent's change sets (docs/platform-agent/contracts.md §4), with the person's own login and the
// restaurant's on-behalf-of headers: the panel reads a card, and only the person who proposed it applies, rejects or
// undoes it.
export default class ChangeSetsManager extends ApiResourceManager {
  get = (id) =>
    this.request({
      method: 'GET',
      url: `/change-sets/${id}`,
    });

  // The rows not listed become skipped; on a partly failed set, only its failed rows (Try again).
  apply = (id, rowIds) =>
    this.request({
      method: 'POST',
      url: `/change-sets/${id}/apply`,
      data: { row_ids: rowIds },
    });

  reject = (id, reason) =>
    this.request({
      method: 'POST',
      url: `/change-sets/${id}/reject`,
      data: reason ? { reason } : {},
    });

  // Undo on a done or partial set (B21): a new waiting set with `undoes` = id, to approve like any change. 409
  // `{ message }` when nothing in it can be undone, or an undo of it already waits.
  undo = (id) =>
    this.request({
      method: 'POST',
      url: `/change-sets/${id}/undo`,
      data: {},
    });
}
